import Action from '../../model/Action'
import State from '../../model/State'
import { entidadeReducer } from './entidadeReducer'
import { queryReducer } from './queryReducer'
import { usuarioReducer } from './usuarioReducer'

export default function reducers(state: State, action: Action) {
    let newState = entidadeReducer(state, action)
    newState = queryReducer(newState, action)
    newState = usuarioReducer(newState, action)
    return newState
}
